import { imageList } from "./../../assets/images";
import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

interface ImageList {
  [key: string]: string;
}

interface LogoProps {
  isTitle?: boolean; // Update the type to accept string value
  isPosition?:boolean;
}

const Logo: React.FC<LogoProps> = (props) => {

  const navigator = useNavigate();

  const redirectHandle=()=>{
    if(!props.isTitle){
      navigator('/dashboard');
    }else{
      navigator('/');
    }
   
  }

  return (
    <>
      <Box style={{cursor:'pointer'}} onClick={() => redirectHandle()} component="section" className={props?.isPosition ? "logo" : 'logoNoPosition'}>
        <img
          src={(imageList as ImageList)["logo"]}
          alt=""
          style={{ verticalAlign: "middle",marginRight: "10px",height:'44px'  }}
        />
        {props.isTitle && (
          <span style={{ fontWeight:600,fontSize:'24px',color:'#fff',letterSpacing:1 }}>Manage My Moves</span>
         
        )}
      </Box>
    </>
  );
};

export default Logo;
